<template>
	<SignUpPageBase :content="this">
		<h4 class="font_lg font_bold margin_title_bottom">{{ $t("signUp.company.title") }}</h4>
		<form class="flex flex_center flex_column w_100">
			<CountrySelect
				class="w_100"
				:labelText="$t('signUp.company.country')"
				v-model="form.companyCountry"
				:excludes="excludedCountries"
				v-validate="modelValidations.companyCountry"
				data-vv-name="companyCountry"
				:error="errors.first('companyCountry')"
				:required="true"
			></CountrySelect>
      <LegalFormSelect
          :label-text="$t('signUp.componyInfo.legalForm')"
          v-model="form.companyLegalStructureId"
          :country="form.companyCountry"
          :company-type=enumDef.companyType.TraderCompany
          data-vv-name="legalStructure"
          v-validate="modelValidations.companyLegalStructureId"
          :error="errors.first('legalStructure')"
          required
      ></LegalFormSelect>
			<md-field :class="[{ 'md-error': errors.has('companyName') }]">
				<label>{{ $t("common.companyName") }}</label>
				<md-input
					v-model="form.companyName"
					v-validate="modelValidations.companyName"
					data-vv-name="companyName"
					autocomplete="organization"
					required
				></md-input>
				<span v-if="errors.has('companyName')" class="validation-error">{{ errors.first("companyName") }}</span>
			</md-field>
		</form>
	</SignUpPageBase>
</template>

<script>
import CountrySelect from "@/components/templates/select/CountrySelect.vue";
import {mapGetters} from "vuex";
import SignUpPageBase from "@/views/register/SignUpPageBase";
import LegalFormSelect from "@/components/templates/select/LegalFormSelect";
import {enumDef} from "@/common/enumDefs";

export default {
	components: {
		LegalFormSelect,
		SignUpPageBase,
		CountrySelect
	},
	data() {
		return {
			enumDef: enumDef,
			form: {
				companyCountry: "",
				companyName: "",
				companyLegalStructureId: null,
			},
			modelValidations: {
				companyCountry: {
					required: true
				},
				companyName: {
					required: true
				},
				companyLegalStructureId: {
					required: true
				}
			}
		};
	},
	created() {
		this.$mergeOnlyExistingProps(this.form, this.signUpData, true);
	},
	computed: {
		...mapGetters({
			signUpData: "local/signUpData"
		}),
		excludedCountries() {
			let excludes = [];
			return excludes;
		}
	},
};
</script>
